import { registerFeatureMessages, type SupportedLocale } from '@/shared/i18n'

/**
 * Merges `features/audience/i18n/<locale>.json` under the `audience` namespace (contract 24
 * §13). English only: ORP-19869 deleted the Turkish catalogs on purpose — never add `tr.json`.
 */
export function registerAudienceMessages(locale: SupportedLocale): Promise<void> {
  return registerFeatureMessages('audience', locale)
}
